
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class CurrentApprovalForm extends Form {
	private static _instance = new CurrentApprovalForm();

	public static getInstance(): CurrentApprovalForm {
		return CurrentApprovalForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {filter: true};
		this.keyFields = ["approvalId"];
	}

	public getName(): string {
		 return 'currentApproval';
	}
}


export class CurrentApprovalFd extends FormData {
	constructor(form: CurrentApprovalForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface CurrentApprovalVo extends Vo {
	approvalStatus?: string, 
	usn?: string, 
	internalRefId?: number, 
	requestType?: string, 
	refText?: string, 
	name?: string, 
	instituteId?: number, 
	contactPerson?: string, 
	approvalId?: number, 
	requestedDate?: string
}
